<!--
frontend-author:bhavya,
backend-author: ,
page-name :Sales by Customer.vue,
page-description :Sales by Customer for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Customer-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <!-- For filter -->
        <router-link
          class="event-link mt-2 float-left fw-semi-bold"
          :to="{name:'CustomerBalancesReport',query:oldRoute}"
        >
          <i class="la la-angle-left la-lg text-decoration-none mr-2"></i>Customer Balances
        </router-link>
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <i class="la la-cog la-lg mr-1"></i>Customize Report
          </template>
          <!-- To add columns -->
          <b-dropdown-item v-b-modal.custom_index>Show/hide columns</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col xl="2" lg="2" md="2" sm="2" class="text-right px-0">
        <router-link class="event-link float-right mt-2" :to="{name:'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <!-- Download excel -->
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item class="dropdown-no-btn">
            <b-dropdown-item @click="exportModal()">
              <span class="la la-download mx-2"></span>Export CustomerBalance
            </b-dropdown-item>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row>
        <b-col md="12" lg="12" sm="12" xs="12" class="px-0">
          <!--  to show the available credit details -->
          <b-alert
            v-if="$route.params.search == '' ? false : true"
            class="alert-transparent alert-shade d-print-none mx-mar mt-2 mb-0"
            :show="true"
          >
            <router-link
              class="page-link float-right"
                :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id},query: {name:$route.query.name,id:$route.query.id,page: page ,show: count,sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,name:$route.query.name,from_date:$route.query.from_date,to_date:$route.query.to_date} }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </router-link>
            <p>
              <span class="fw-semi-bold">Date/Type/Status/Number/Sales/Balance due:</span>
              <strong>{{ ' '+$route.params.search }}</strong>
            </p>
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4
              class="fw-semi-bold text-truncate"
            >Customer Balance Details for - {{ $route.query.name }}</h4>
            <p class="text-sm text-muted mb-2">As of {{ getDateFormat($route.query.report_date) }}</p>
          </div>
          <div
            :class="this.$route.params.search=='' ?'table-responsive':'table_search'"
            id="reportScrollCol"
          >
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->
              <thead>
                <tr>
                  <th style="width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'view_date',report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                    >
                      Date
                      <small class="text-muted" v-if="label == 'view_date'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:100px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'view_type',report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                    >
                      Type
                      <small class="text-muted" v-if="label == 'view_type'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:110px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'view_status',report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                    >
                      Status
                      <small class="text-muted" v-if="label == 'view_status'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:120px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'view_code',report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                    >
                      Number
                      <small class="text-muted" v-if="label == 'view_code'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'view_total',report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                    >
                      Amount
                      <small class="text-muted" v-if="label == 'view_total'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'view_due_amount',report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                    >
                      BALANCE
                      <small class="text-muted" v-if="label == 'view_due_amount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <!-- Customize column -->
                  <th
                    v-for="(column,index) in reported_columns"
                    v-if="column.checked == true"
                    :key="column.id"
                    :class="{'text-right':column.align=='right'}"
                    :style="{'width':column.colWidth+'px !important'}"
                  >
                    <b-row
                      v-b-tooltip.top
                      :title="column.title"
                      v-if="column.field=='export_total_amount'||column.field=='export_due_amount'"
                    >
                      <b-col sm="10" class="pr-0">
                        <router-link
                          class="text-dark text-decoration-none"
                          :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field,report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                        >
                          <span class="text">{{ column.title }}</span>
                        </router-link>
                      </b-col>
                      <b-col sm="2" class="pl-0">
                        <small class="text-muted" v-if="label == column.field">
                          <i
                            :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </b-col>
                    </b-row>
                    <template v-else>
                      <router-link
                        class="text-dark text-decoration-none"
                        :to="{ name : 'CustomerBalancesFilter',params:{id:$route.params.id,filter_by:$route.params.filter_by},query: {name:$route.query.name,id: $route.query.id,sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field,report_date:$route.query.report_date,page: page,show: show,select_columns:$route.query.select_columns,filter_by:$route.query.filter_by} }"
                      >
                        {{ column.title }}
                        <small class="text-muted" v-if="label == column.field">
                          <i
                            :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </template>
                  </th>
                  <!-- End of customize column header -->
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="6" class="text-center">No data to display</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="item in lists" :key="item.id">
                    <td>{{ getDateFormat(item.view_date) }}</td>
                    <td>{{ item.view_type }}</td>
                    <td>{{ item.view_status }}</td>
                    <td>{{ item.view_code }}</td>
                    <td
                      class="text-right"
                    >{{ orgCurrencySymbol+" "+Number(item.view_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="text-right"
                    >{{ orgCurrencySymbol+" "+Number(item.view_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <!-- Customize column -->
                    <td
                      class="text-right"
                      v-for="(column,index) in reported_columns"
                      v-if="column.checked == true"
                      :key="column.id"
                    >
                      <span v-if="column.field=='export_total_amount'">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span v-else-if="column.field=='export_due_amount'">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        item.cus_currency,
                        "currency_symbol"
                        )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>
                      <span
                        v-else-if="column.field=='due_date'"
                      >{{getDateFormat(item[column.field]) }}</span>
                      <span v-else>{{item[column.field] }}</span>
                    </td>
                  </tr>
                  <!-- End of customize column data -->
                  <tr>
                    <td colspan="4" class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.view_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.view_due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      v-if="reported_columns.length > 0&& show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </template>
              </tbody>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="lists.length > 0||arrow"
        style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
        class="px-pad"
      >
        <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
          <nav class="float-left" v-if="lists.length > 0">
            <p>
              Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
              of {{ total_count }} entries
              <span
                class="btn-group dropdown"
              >
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  size="xs"
                  :show="false"
                  :text="count"
                  left
                >
                  <router-link
                    :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: 1,show: 10,search:$route.query.search} }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: 1,show: 25,search:$route.query.search} }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: 1 ,show: 50,search:$route.query.search} }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                  </router-link>
                </b-dropdown>
              </span> rows per page
            </p>
          </nav>
        </b-col>
        <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
          <div v-if="arrow">
            <a @click="left('#reportScrollCol')" class="mr-2">
              <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
            </a>
            <a @click="right('#reportScrollCol')">
              <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
            </a>
          </div>
        </b-col>
        <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
          <template v-if="show<total_count">
            <nav class="float-right">
              <ul class="pagination">
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: page - 1 ,show: count,search:$route.query.search} }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: 1 ,show: count,search:$route.query.search} }"
                  >First</router-link>
                </li>
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: page - 1 ,show: count,search:$route.query.search} }"
                    >Previous</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Previous</a>
                  </template>
                </li>
                <li class="page-item">
                  <template v-if="total_count > (page * count)">
                    <router-link
                      class="page-link"
                      :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: page + 1,show: count,search:$route.query.search } }"
                    >Next</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Next</a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: Math.ceil(total_count / count),show: count,search:$route.query.search } }"
                  >Last</router-link>
                </li>
                <li class="page-item">
                  <template v-if="total_count > (page * count)">
                    <router-link
                      class="page-link"
                      :to="{ name : 'CustomerBalancesFilter',query: {sort:sort,label:label,id:$route.query.id,filter_by:$route.query.filter_by,select_columns:$route.query.select_columns,name:$route.query.name,report_date:$route.query.report_date,page: page + 1,show: count,search:$route.query.search } }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </template>
                </li>
              </ul>
            </nav>
          </template>
        </b-col>
      </b-row>
    </div>
    <!-- Customize column -->
    <b-modal
      :no-close-on-backdrop="true"
      id="custom_index"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      @ok="onRunReport"
      ref="runreport"
    >
      <b-row>
        <b-col>
          <p class="fw-semi-bold pl-2">Customer Advance Filter</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:25px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
      </b-row>
    </b-modal>
    <!--  Model-->
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Customer Balances'"
      @downloaded="export_modal=false"
    />
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { formatDate } from "@/mixins/formatDate";
import getPageTitle from "@/utils/get-page-title"; // to set page title
function getPageSalesByCustomers(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";

  store
    .dispatch("reports/fetchCustomerBalanceFilterDetailLists", {
      page: currentPage,
      show: show,
      search: search,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      routeTo.params.search = search;
      next();
    });
}
export default {
  components: {
    VueBootstrapTypeahead
  },
  mixins: [formatDate, scrollTable],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    label: [String, Number],
    sort: [String, Number]
  },
  name: "CustomerBalancesFilter",
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        Date: "view_date",
        Type: "view_type",
        Status: "view_status",
        Number: "view_code",
        Amount: "view_total",
        BALANCE: "view_due_amount"
      },
      show_columns: [],
      reported_columns: [],
      available_columns: [
        {
          Group: "amount",
          field: "sales_person_name",
          title: "Sales person",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "amount",
          field: "due_date",
          title: "Due Date",
          checked: false,
          colWidth: 140,
          align: ""
        },
        {
          Group: "amount",
          field: "ref_no",
          title: "Reference No",
          checked: false,
          colWidth: 140,
          align: ""
        },
        {
          Group: "amount",
          field: "export_total_amount",
          title: "Total Amount(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "amount",
          field: "export_due_amount",
          title: "Due Amount(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        }
      ],
      columns: this.$route.query.show_columns,
      error_show: false,
      items: [],
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      Selected: "",
      org_name: this.$AppDetails.organization.comp_name || ""
    };
  },

  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchCustomerBalanceFilterDetailExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,
          search: search,
          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },
    closeModal(id) {
      this.$refs[id].hide();
    },

    addNewRow() {
      this.items.push({
        filter_matching: "",
        field: "",
        comparator: "",
        value: ""
      });
      this.items[0].filter_matching = "When";
    },
    onRunReport(evt) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.show_columns_length = JSON.parse(
            JSON.stringify(this.show_columns)
          ).length;
          this.reported_columns = JSON.parse(
            JSON.stringify(this.available_columns)
          );
          //To add export for selected columns
          for (var i = 0; i < this.reported_columns.length; i++) {
            if (this.reported_columns[i].checked == true) {
              this.export_xl[
                this.reported_columns[i].title
              ] = this.reported_columns[i].field;
            } else {
              delete this.export_xl[this.reported_columns[i].title];
            }
          }
          evt.preventDefault();
          this.$router.push({
            name: this.$route.name,
            query: {
              report_date: this.$route.query.report_date,
              label: this.$route.query.label,
              sort: this.$route.query.sort,
              id: this.$route.query.id,
              filter_by: this.$route.query.filter_by,
              name: this.$route.query.name,
              select_columns: JSON.stringify({
                columns: JSON.stringify(this.show_columns)
              })
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    getDateRange(event) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    },
    removeRow(index) {
      this.items.splice(index, 1);
      this.items[0].filter_matching = "When";
    }
  },
  created() {
    if (
      Object.entries(this.$route.query).length === 1 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          name: this.$route.query.name,
          id: this.$route.params.id,
           filter_by: this.$route.params.filter_by,
          report_date: this.to_date,
        }
      });
    }

    document.title = getPageTitle(
      this.$route.query.name + " | " + this.$route.meta.title
    );
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageSalesByCustomers(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    getPageSalesByCustomers(routeTo, next);
  },
  computed: {
    ...mapState({
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      export: state => state.reports.export
    }),
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"]),
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      }
    }
  }
};
</script>

<!--  Sales by Customer style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 40px 40px 60px;
  background-color: #fff;
}
</style>